import { SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Body } from "@hypercard/web-components";
import { Separator } from "@/components/ui/separator";
import { useState } from "react";
import { CustomFieldEntity } from "@common/utils/graphql";
import { Button } from "@/components/ui/button";
import { EditCustomFieldForm } from "./EditCustomFieldForm";
import { CustomListOptions } from "./CustomListOptions";
import { cn } from "@/utils/utils";
import { isListField } from "@common/components/CustomFields";

type Props = {
  customField: CustomFieldEntity;
};

export const ViewCustomFieldDetails = ({ customField }: Props) => {
  const [isEditingField, setIsEditingField] = useState(false);

  if (isEditingField) {
    return (
      <EditCustomFieldForm
        customField={customField}
        onBack={() => setIsEditingField(false)}
      />
    );
  }

  return (
    <>
      <SheetHeader>
        <div className="flex items-center justify-between">
          <div>
            <SheetTitle>{customField.name}</SheetTitle>
            <Body size="sm" weight="regular" className="text-white/70">
              {`${customField?.listOptions?.length ?? 0} ${customField?.listOptions?.length === 1 ? "option" : "options"}`}
            </Body>
          </div>
        </div>
      </SheetHeader>
      <div className="flex w-full grow flex-col overflow-hidden px-sheet-gap pb-sheet-gap">
        <div className="flex space-x-8">
          <div className="space-y-2">
            <Body size="sm" weight="regular" className="text-white/70">
              Field Type
            </Body>
            <Body size="sm" weight="medium" className="capitalize">
              {customField.type}
            </Body>
          </div>
          <div className="space-y-2">
            <Body size="sm" weight="regular" className="text-white/70">
              Field State
            </Body>
            <Body size="sm" weight="medium" className="capitalize">
              {customField.state}
            </Body>
          </div>
        </div>
        {isListField(customField) && (
          <>
            <Separator className="my-4 bg-white/10" />
            <CustomListOptions
              customFieldEntityName={customField.name}
              customFieldEntityId={customField.id}
            />
          </>
        )}
        <div
          className={cn("mt-3 flex flex-col justify-end gap-3", {
            grow: !isListField(customField),
          })}
        >
          <Button size="lg" onClick={() => setIsEditingField(true)}>
            Edit Custom Field
          </Button>
        </div>
      </div>
    </>
  );
};
